if (!customElements.get('countdown-timer')){
  customElements.define('countdown-timer', class CountdownTimer extends HTMLElement {
    constructor() {
      super();

      this.duration = this.hasAttribute('timer-duration')?parseInt(this.getAttribute('timer-duration')):undefined;
      this.save_state = this.hasAttribute('timer-save-state')?this.getAttribute('timer-save-state'):undefined;
      this.on_finish = this.hasAttribute('timer-on-finish')?this.getAttribute('timer-on-finish'):undefined;
      this.originalText= this.innerText;
      this.timer = null;

      this.render();

      if (this.save_state && localStorage.getItem('countdownState')) {
        var savedState = JSON.parse(localStorage.getItem('countdownState'));
        this.duration = savedState.duration;
        this.render();
      }
    }

    connectedCallback() {
      this.start();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    start() {
      clearInterval(this.timer);

      this.timer = setInterval(() => {
        this.duration--;

        if (this.duration <= 0) {
          clearInterval(this.timer);
          this.clearState();
          this.onComplete();
        } else {
          this.saveState();
          this.render();
        }
      }, 1000);
    }

    saveState() {
      var state = {
        duration: this.duration
      };
      localStorage.setItem('countdownState', JSON.stringify(state));
    }

    clearState() {
      localStorage.removeItem('countdownState');
    }

    render() {
      var days = Math.floor(this.duration / (24 * 60 * 60));
      var hours = Math.floor((this.duration % (24 * 60 * 60)) / (60 * 60));
      var minutes = Math.floor((this.duration % (60 * 60)) / 60);
      var seconds = Math.floor(this.duration % 60);

      this.querySelectorAll('span').forEach((span) => {
        switch (span.className) {
          case 'countdown-timer-days':
            span.innerText = days > 9 ? days : "0" + days;
            break;
          case 'countdown-timer-hours':
            span.innerText = hours > 9 ? hours : "0" + hours;
            break;
          case 'countdown-timer-minutes':
            span.innerText = minutes > 9 ? minutes : "0" + minutes;
            break;
          case 'countdown-timer-seconds':
            span.innerText = seconds > 9 ? seconds : "0" + seconds;
            break;
        }
      });
    }

    onComplete() {
      if (this.on_finish) {
        this.setText(this.on_finish);
      } else {
        this.start();
      }
    }

    setText(text) {
      this.innerText = `<div>${text}</div>`;
      this.clearState();
    }
  })
}